/**
 * Contact Form 7: a field's error goes once the field is edited.
 *
 * The forms are validated when they are sent and not while they are filled
 * in (lib/forms.php puts them in CF7's "novalidate"), which also stops CF7
 * taking an error back as the field is corrected. So this takes it back: the
 * first edit of a field marked invalid removes its message, the marking on
 * its control, and its line in the screen reader's list -- what CF7 itself
 * removes before it validates again. Nothing is checked here; whether the new
 * answer will do is the next send's business.
 *
 * Delegated from the document, so it covers fields added after load, like
 * the people on the Christmas party form.
 */

const WRAP = '.wpcf7-form-control-wrap[data-name]';

/**
 * Removes one field's error.
 *
 * @param {HTMLFormElement} form The form.
 * @param {HTMLElement}     wrap The field's wrapper, which names it.
 */
function clearError(form, wrap) {
	const { name } = wrap.dataset;

	wrap.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) =>
		tip.remove()
	);

	wrap.querySelectorAll('[aria-invalid]').forEach((control) =>
		control.setAttribute('aria-invalid', 'false')
	);

	wrap.querySelectorAll('.wpcf7-form-control').forEach((control) => {
		control.classList.remove('wpcf7-not-valid');
		control.removeAttribute('aria-describedby');
		control.setCustomValidity?.('');
	});

	// CF7 lists each error for screen readers under an id made the same way.
	const unitTag = form.querySelector('input[name="_wpcf7_unit_tag"]')?.value;

	if (unitTag) {
		const id = `${unitTag}-ve-${name}`.replaceAll(/[^0-9a-z_-]+/gi, '');

		form.closest('.wpcf7')
			?.querySelector(`.screen-reader-response li#${id}`)
			?.remove();
	}
}

/**
 * @param {Event} event An input or change event.
 */
function onEdit(event) {
	const form = event.target.closest?.('.wpcf7-form');
	const wrap = event.target.closest?.(WRAP);

	if (!form || !wrap || !wrap.querySelector('.wpcf7-not-valid-tip')) {
		return;
	}

	clearError(form, wrap);
}

export function initFormErrorClearing() {
	// input for typing, change for radios, checkboxes, selects and files.
	document.addEventListener('input', onEdit);
	document.addEventListener('change', onEdit);
}
